<emm-management-layout>
    <emm-progress-bar [isLoading$]="centerLoading$"></emm-progress-bar>
    <emm-search-filter
        [addDialog]="true"
        [attr.data-testid]="'operator_emergency_search_bar'"
        [displaySearchWithOptions]="false"
        [fields]="fields"
        [isAdminOrAuthor]="this.isAdmin || this.isAuthor"
        [isSuperAdmin]="this.isSuperAdmin"
        layout-center-header
        (add)="openCreateEmergencyItemDialog()"
        (filter)="onFilter($event)"
    ></emm-search-filter>
    <emm-generic-items-tree *ngIf="(nodes$ | async)?.length > 0"
        [contextMenuActions]="emergencyItemsContextMenuActions"
        [disableContextActions]="centerLoading$ | async"
        [items]="nodes$ | async"
        layout-center-content
        [options]="options"
        [readonly]="isReadOnly$ | async"
        [nodesToExpand]="nodesToExpand"
    ></emm-generic-items-tree>
    <emm-management-attributes-header
        *ngIf="emergencyItemDetail$ | async as emergency"
        layout-right-header
        [name]="emergency['name']"
        [tag]="emergency.tag"
    ></emm-management-attributes-header>
    <emm-operator-locks-form
        #form
        layout-right-content
        [isSuperAdmin]="isSuperAdmin"
        [isAdmin]="isAdmin"
        [isAuthor]="isAuthor"
    ></emm-operator-locks-form>
    <emm-management-attributes-footer
        *ngIf="emergencyItemDetail$ | async as emergency"
        [disableCancel]="!emergencyItemsForm || !emergencyItemsForm.isFormReady()"
        [disableUpdate]="!emergencyItemsForm || !emergencyItemsForm.hasChanges()"
        layout-right-footer
        (cancel)="emergencyItemsForm.cancel()"
        (submit)="emergencyItemsForm.submit(emergency.tag)"
        class="emergency-items-footer"
    ></emm-management-attributes-footer>
</emm-management-layout>
